import { useMemo } from 'react';

import { SmartDropdown } from '@stratumn/atomic';

import type { StrictRJSFSchema } from '@rjsf/utils';

import { isLockedWidget } from '@/components/forms/utils/links';
import {
  buildSelectableGroupsList,
  type WorkflowContext,
  type WorkflowGroupOptions
} from '@/components/forms/utils/workflowContext';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import type { WidgetWriterProps } from '../widget.type';

type GroupSchema = {
  formatOptions: WorkflowGroupOptions;
} & StrictRJSFSchema;

type Props = WidgetWriterProps & {
  schema: GroupSchema;
};

export const GroupSelection = ({
  id,
  onChange,
  value = '',
  disabled = false,
  invalid = false,
  formContext,
  schema
}: Props) => {
  // check if the widget is locked because of forms links
  const isLocked = isLockedWidget(id, formContext.links);

  const inputOptions = useMemo(() => {
    // get selectable options from the form's workflowContext
    const groups = buildSelectableGroupsList(
      formContext.workflowContext as WorkflowContext,
      schema.formatOptions
    );

    return groups.map(({ label, name, avatar }) => ({
      value: label,
      label: name,
      prefix: <AvatarComponent name={name} size={22} source={avatar} />
    }));
  }, [formContext.workflowContext, schema.formatOptions]);

  return (
    <SmartDropdown
      disabled={disabled || isLocked}
      id={id}
      invalid={invalid}
      label={schema.title}
      onSelect={onChange}
      options={inputOptions}
      shadows
      value={value}
    />
  );
};
